import React from 'react'

import {
  Sheet,
  SheetCloseButton,
  SheetOverlay,
  SheetContent,
  SheetTitle,
} from '@wartek-id/sheet-v1'

import { EmptyState } from 'app/ProfileRevampPage/components/EmptyState'

interface IEditPersonalDataDrawerProps {
  isOpen: boolean
  onClose: () => void
  onCloseButtonClicked: () => void
}

export const EditPersonalDataDrawer = ({
  isOpen,
  onClose,
  onCloseButtonClicked,
}: IEditPersonalDataDrawerProps) => {
  return (
    <Sheet isOpen={isOpen} onClose={onClose} sheetSize="auto">
      <SheetOverlay />
      <SheetContent className="max-w-xl m-auto !z-[1000]">
        <SheetCloseButton onClick={onCloseButtonClicked} />
        <SheetTitle bold bordered>
          Edit data pribadi
        </SheetTitle>
        <div className="p-4">
          <EmptyState
            imageSrc="/icon/typing-monitor.png"
            imgWidth="84px"
            imgHeight="84px"
            description="Untuk mengubah data pribadi, harap hubungi koordinator sekolah untuk membantu Anda."
          />
        </div>
      </SheetContent>
    </Sheet>
  )
}
